import {
	FAMILY_MEMBER_CREATE_REQUESTING,
	FAMILY_MEMBER_CREATE_SUCCESS,
	FAMILY_MEMBER_CREATE_ERROR,
	FAMILY_MEMBER_UPDATE_REQUESTING,
	FAMILY_MEMBER_UPDATE_SUCCESS,
	FAMILY_MEMBER_UPDATE_ERROR,
	FAMILY_MEMBER_RESET_STATES,
	FAMILY_MEMBER_FILL_DATA,
	FAMILY_MEMBER_FILL_DATA_SUCCESS,
	FAMILY_MEMBER_FILL_DATA_ERROR,
	FAMILY_MEMBER_CLEAN_VALUES,
	FAMILY_MEMBER_DELETE_REQUESTING
} from './constants';

const initialState = {
	requesting: false,
	success: false,
	error: "",
	values: {},
	familyMember: {}
};

const reducer = (state = initialState, action) => {
	switch (action.type){
		case FAMILY_MEMBER_CREATE_REQUESTING:
		    return {
		   	    ...state,
		   	    requesting: false,
		   	    success: false,
		   	    error: ""
		    };
		case FAMILY_MEMBER_CREATE_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: "",
		    	familyMember: action.familyMember
		    };  
		case FAMILY_MEMBER_CREATE_ERROR:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: action.error
		    };
		case FAMILY_MEMBER_UPDATE_REQUESTING:
		    return {
		   	    ...state,
		   	    requesting: false,
		   	    success: false,
		   	    error: ""
		    };
		case FAMILY_MEMBER_UPDATE_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: ""
		    };  
		case FAMILY_MEMBER_UPDATE_ERROR:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: action.error
		    };
		case FAMILY_MEMBER_FILL_DATA:
		    return {
		    	...state,
		    	requesting: true,
		    	success: false,
		    	error: ""
		    };    
		case FAMILY_MEMBER_FILL_DATA_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: "",
		    	familyMember: action.family
		    };    
		case FAMILY_MEMBER_FILL_DATA_ERROR: 
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: action.error
		    }; 
		case FAMILY_MEMBER_DELETE_REQUESTING: 
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: "",
		    	familyMember: {}
		    }; 
		case FAMILY_MEMBER_CLEAN_VALUES:
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: "",
		    	familyMember: {},
		    	values: {}
		    };       
		case FAMILY_MEMBER_RESET_STATES:
		    return {
		    	...state,
                requesting: false,
                success: false,
                error: ""
		    };  
		default: 
		    return state;      
	}
}

export default reducer;